  import { Component, ElementRef, NgZone, OnInit, ViewChild } from '@angular/core';
  import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
  import { ActivatedRoute, Router } from '@angular/router';
  import { ApiService } from 'app/shared/services/api.service';
  import { SessionStorageService } from 'app/shared/services/session-storage.service';
  import { ToastrService } from 'ngx-toastr';
  import { MapsAPILoader } from '@agm/core';
 
  
  @Component({
    selector: 'app-add',
    templateUrl:'./add.component.html',
    styleUrls: ['./add.component.scss']
  })
  export class AddComponent implements OnInit {
    @ViewChild('vform') validationForm: FormGroup;
    @ViewChild("search")
    public searchElementRef: ElementRef;
    employeeForm:FormGroup;
    fileData:File
    employeeFormSubmitted:boolean=false;
    selectedBusinessId = null
    statusList: any[] = [{name:"Activated",value:"activated"},
    {name:"Pending",value:"Pending"},,];
    editData = null;

 teamId= "631ad9d8ce5c666542591bee" 
 selectTeam:any=null
 teamList=[];
 selectType:any=null
 typeList=[];
 typeId=  "6344000d91f6bc691e775faf" 
 address: string;
 latitude: number;
 longitude: number;
 zoom: number;
 emp_id:any

 technology_catId='6319d5025ab9e462a96cfbba'
 technology_List=[]
 selectedTechnology = null
 private geoCoder;

 genderList=[
  {name:'Male',id:'male'},
  {name:'Female',id:'female'}

 ]
 selected_gender=null

 employee={
  employeetype:[{_id:''}],
  empcode:'',
  name:'',
  phone:'',
  email:'',
  previousemployement:'',
  qualification:'',
  address:'',
  gender:'',
  marriagestatus: '',
  fathername:'',
  mothername:'',
  salary:'',
  designation:'',
  pan:'',
  linkedIn:'',
  accountno:'',
  dateofjoining:'',
  dateofrelieving:'',
  responsibilities:'',
  dob:'',
  documents:'',
  team:[{_id:''}],
  notes:'',
  admin_notes:'',
  technology: [{_id:''}],
  lat:0,
  lng:0,
  guidelines:'',
  skills: [{_id:''}],
  report_to : [{_id:''}],
  refrence: '' ,
 }
 skill_cat_Id='6319d3595ab9e462a96cfb06'
 tagsList =[]
 selected_skillTag = null
 users_List =[]
 selected_reportTo = null
 select_refrence=null
 refrence_List =[]
    constructor(private formBuilder: FormBuilder,
      public toastr: ToastrService,
      private mapsAPILoader: MapsAPILoader,
      private ngZone: NgZone,
      public apiService:ApiService,private activatedroute:ActivatedRoute,
      private route:Router,
      private session: SessionStorageService)
       { 
        this.locationAutoComplete();
        this.getEmployeeType();
        this.getAllUsers()
        this.activatedroute.paramMap.subscribe(params => { 
          this.emp_id = params.get('id'); 
      });    
      }
  
    ngOnInit() {
     
      this.getSkillTagByCategory()
      this.getAllEmployee()
      if(this.emp_id){
        this.getEmployeeById()
      }
      this.getBadegeTagByCategory();
      
      this.getEmployeeType()
      this.getTechnologyList()
      this.employeeForm=this.formBuilder.group({
        
        employeetype: ['', Validators.required],
        empcode: ['', Validators.required],
        name: ['', Validators.required],
        phone: ['', Validators.required],
        email: ['', [Validators.required, Validators.email]],
        previousemployement: ['', Validators.required],
        qualification: ['', Validators.required],
        address: ['', Validators.required],
        gender: ['', Validators.required],
        marriagestatus: ['', Validators.required],
        location: ['', Validators.required],
        fathername: ['', Validators.required],
        mothername: ['', Validators.required],
        salary: ['', Validators.required],
        designation: ['', Validators.required],
        pan: ['', Validators.required],
        accountno: ['', Validators.required],
        linkedIn: ['', Validators.required],
        previousemployemnt: ['', Validators.required],
        qualificaiton: ['', Validators.required],
        dateofjoining: ['', Validators.required],
        dateofrelieving: ['', Validators.required],
        responsibilities: ['', Validators.required],
        dob: ['', Validators.required],
        documents: ['', Validators.required],
        team: ['', Validators.required],
        created_by: ['', Validators.required],
        last_modified: ['', Validators.required],
        notes: ['', Validators.required],
        admin_notes: ['', Validators.required],
        lat:['', Validators.required],
        lng:['', Validators.required],
        guidelines : ['',]
      })
      this.employee.marriagestatus ='unmarried'
      this.selected_gender = 'male'
    }
   
   
    get rf() {
      return this.employeeForm.controls;
    }
    getAllEmployee(){
      this.apiService.getEmployeeList(1,100).subscribe((res:any)=>{
        this.users_List=res.items
      })
    }
    getReportToId(event){
      this.selected_reportTo
    }
    
    submit(){   
     
      let body={
        employeetype:this.selectType,
        empcode:this.employeeForm.value.empcode,
        name:this.employeeForm.value.name,
        phone:this.employeeForm.value.phone,
        email:this.employeeForm.value.email,
        previousemployement:this.employeeForm.value.previousemployement,
        qualification:this.employeeForm.value.qualification,
        address:this.address,
        gender:this.selected_gender,
        marriagestatus: this.employee.marriagestatus,
        fathername:this.employeeForm.value.fathername,
        mothername:this.employeeForm.value.mothername,
        salary:this.employeeForm.value.salary,
        designation:this.employeeForm.value.designation,
        pan:this.employeeForm.value.pan,
        linkedIn:this.employeeForm.value.linkedIn,
        accountno:this.employeeForm.value.accountno,
        dateofjoining:this.employeeForm.value.dateofjoining,
        dateofrelieving:this.employeeForm.value.dateofrelieving,
        responsibilities:this.employeeForm.value.responsibilities,
        dob:this.employeeForm.value.dob,
        documents:this.employeeForm.value.documents,
        team:this.selectTeam,
        notes:this.employeeForm.value.notes,
        admin_notes:this.employeeForm.value.admin_notes,
        lat:this.latitude,
        lng:this.longitude,
        technology: this.selectedTechnology,
        skills: this.selected_skillTag,
        report_to: this.selected_reportTo,
        guidelines: this.employeeForm.value.guidelines,
        refrence: this.select_refrence ,
      }
      if(!this.emp_id){
        this.apiService.addEmployee(body).subscribe((res:any)=>{
          if(res.statusCode === 200){
            this.toastr.success(res.message)
            this.route.navigate(['/employees/list'])    
           }
         else{this.toastr.error(res.error)}
        })
      }
      if(this.emp_id){
        this.employee.gender=this.selected_gender
        this.employee.employeetype=this.selectType
        this.employee.technology=this.selectedTechnology
        this.employee.team=this.selectTeam
        this.employee.skills = this.selected_skillTag
        this.employee.report_to = this.selected_reportTo
        this.apiService.updateEmployee(this.emp_id,this.employee).subscribe((res:any)=>{
          if(res.statusCode === 200){
            this.toastr.success(res.message)
            // this.route.navigate(['/employees/list'])  
            window.history.back()    
           }
         else{this.toastr.error(res.error)}
        })
      }
    }
   back(){
    this.route.navigate(['/employees/list'])    
   } 
   getSkillTagByCategory(){
    this.apiService.getTagByTagCatgoryId(this.skill_cat_Id).subscribe((res:any)=>{
      this.tagsList=res.data
    })
   }
   getTagsId(event:any){
    this.selected_skillTag
  }
   getEmployeeById() {
    this.apiService.getEmployeeById(this.emp_id).subscribe((res: any) => {
      this.employee.qualification = res.data.qualification;
      this.employee.name = res?.data?.name
      this.employee.email = res?.data?.email
      this.employee.phone = res?.data?.phone
      this.employee.address = res?.data?.location?.address
      this.employee.empcode = res?.data?.empcode
      this.employee.gender = res?.data?.gender
      this.employee.accountno = res?.data?.accountno
      this.employee.dateofjoining = res?.data?.dateofjoining
      this.employee.dateofrelieving = res?.data?.dateofrelieving
      this.employee.designation = res?.data?.designation
      this.employee.dob = res?.data?.dob
      this.employee.marriagestatus = res?.data?.marriagestatus
      this.employee.mothername = res?.data?.mothername
      this.employee.fathername = res?.data?.fathername
      this.employee.salary = res?.data?.salary
      this.employee.pan = res?.data?.pan
      this.employee.linkedIn = res?.data?.linkedIn
      this.employee.previousemployement = res?.data?.previousemployement
      this.employee.responsibilities = res?.data?.responsibilities
      this.employee.documents = res?.data?.documents
      this.employee.notes = res?.data?.notes
      this.employee.admin_notes = res?.data?.admin_notes
      this.employee.guidelines = res?.data?.guidelines
      if(res?.data?.skills){
        this.selected_skillTag = res?.data?.skills?.map(item => item?._id)
        this.employee.skills = this.selected_skillTag
      }
      if(res?.data?.report_to){
        this.selected_reportTo = res?.data?.report_to?.map(item => item?._id)
        this.employee.report_to = this.selected_reportTo
      }
     
      if(res?.data?.employeetype){
        this.selectType  = res?.data?.employeetype?.map((item)=>item?._id)
        this.employee.employeetype= this.selectType
      }
      if(res?.data?.team){
        this.selectTeam  = res?.data?.team?.map((item)=>item?._id)
        this.employee.team= this.selectTeam
      }
      if(res?.data?.technology){
        this.selectedTechnology  = res?.data?.technology?.map((item)=>item?._id)
        this.employee.technology= this.selectedTechnology
      }

    })
  }
   getBadegeTagByCategory() {
    this.apiService.getTagByTagCatgoryId(this.teamId).subscribe((res: any) => {
      this.teamList = res.data
    })
  }
  getTeamId(event:any){
    this.selectTeam
  }
  getEmployeeType(){
    this.apiService.getTagByTagCatgoryId(this.typeId).subscribe((res:any)=>{
      this.typeList=res?.data
    })
  }
  getTypeId(event:any){
    this.selectType
  }
  getGenderId(event){
    this.selected_gender
   }
   locationAutoComplete() {
    this.mapsAPILoader.load().then(() => {
      this.geoCoder = new google.maps.Geocoder;
  
      let autocomplete = new google.maps.places.Autocomplete(this.searchElementRef?.nativeElement);
      autocomplete.addListener('place_changed', () => {
        this.ngZone.run(() => {
          let place: google.maps.places.PlaceResult = autocomplete.getPlace();
          this.address = place.formatted_address;
          console.log('address', this.address)
          // verify result
          if (place.geometry === undefined || place.geometry === null) {
            return;
          }
  
          // set latitude, longitude and zoom
          this.latitude = place.geometry.location.lat();
          this.longitude = place.geometry.location.lng();
          this.zoom = 12;
          if(this.emp_id){
            this.address = place.formatted_address;
            this.latitude = place.geometry.location.lat();
            this.longitude = place.geometry.location.lng();
            this.employee.address = this.address
            this.employee.lat = this.latitude
            this.employee.lng = this.longitude

          }
          console.log("lat lng",this.latitude,this.longitude)
        });
      });
    });
  }
  getTechnologyList(){
    this.apiService.getTagByTagCatgoryId(this.technology_catId).subscribe((res:any)=>{
      this.technology_List=res.data.slice(0, 4)
    })
   }
   getTechnologyId(event){
    this.selectedTechnology
   }
  ngOnDestroy(){
    this.session.removeItem('employee-data')
  }
  getAllUsers(){
    this.apiService.getAllUsers(1,1000).subscribe((res:any)=>{
      this.refrence_List = res?.data?.items
    })
  }
  getRefrenceId(event){
    this.select_refrence
  }

  }
  
  
